// bind multiple handlers to an event
const callAllHandlers = (...handlers) => (...args) => handlers.forEach(handler => handler && handler(...args))

export default callAllHandlers



// WEBPACK FOOTER //
// ./src/utilities/callAllHandlers.js